const Chat = {
    state: {
        newMsg: {},
        lawyerThirdId:'',
        noreadtotal:0,
        showTip:true,
        chatAILink:false,
        chatAIMsg:'',
        thinking:''
    },
    mutations: {
        setNewMsg(state, info) {
            state.newMsg = info;
        },
        setLawyerThirdId(state, info) {
            state.lawyerThirdId = info;
        },
        setnoreadtotal(state, info) {
            state.noreadtotal = info;
        },
        setshowTip(state, info) {
            state.showTip = info;
        },
        setchatAILink(state, info) {
            state.chatAILink = info;
        },
        setAIMsg(state, info) {
            state.chatAIMsg = info;
        },
        setThinking(state, info) {
            state.thinking = info;
        },
    },
    actions: {
        onNewMsg: function (context, payload) {
            context.commit("setNewMsg", payload);
        },
        onLawyerThirdId: function (context, payload) {
            context.commit("setLawyerThirdId", payload);
        },
        onnoreadtotal: function (context, payload) {
            context.commit("setnoreadtotal", payload);
        },
        onshowTip: function (context, payload) {
            context.commit("setshowTip", payload);
        },
        onchatAILink: function (context, payload) {
            context.commit("setchatAILink", payload);
        },
        onAIMsg: function (context, payload) {
            context.commit("setAIMsg", payload);
        },
        onThinking: function (context, payload) {
            context.commit("setThinking", payload);
        },
    },
    getters: {
        onNewMsg(state) {
            return state.newMsg
        },
        onLawyerThirdId(state) {
            return state.lawyerThirdId
        },
        onnoreadtotal(state) {
            return state.noreadtotal
        },
        onshowTip(state) {
            return state.showTip
        },
        onchatAILink(state) {
            return state.chatAILink
        },
        onAIMsg(state) {
            return state.chatAIMsg
        },
        onThinking(state) {
            return state.thinking
        },
    }

};
export default Chat;